import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({

    st1: {
        fill: '#000082',
    },

    st2: {
        fill: '#FFFFFF',
    },

    st4: {
        fontSize: '16px',
        fontWeight: '500',
    },

    st5: {
        fill: '#010134',
    },

}));
